<!-- 德育报表 -->
<template>
   <div class="box" >
     <div class="fuzzy-matching-top">
        <el-row >
           <el-col :span="5">
              <el-form-item label="部门:">
                 <el-select v-model="searchFoem.department" placeholder="请选择" @change="changeBtn">
                    <el-option v-for="item in departmentList" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                 </el-select>
              </el-form-item>
           </el-col>
           <el-col :span="5">
              <el-form-item label="任务名称:">
           <el-select v-model="searchFoem.checkTaskId" filterable placeholder="请选择">
             <el-option v-for="item in taskName" :key="item.id" :label="item.name" :value="item.id">
             </el-option>
           </el-select>
         </el-form-item>
           </el-col>
           <el-col :span="5">
              <el-form-item label="开始时间:">
                 <el-date-picker v-model="searchFoem.startTime" type="datetime" format="YYYY-MM-DD HH:mm:ss"
                 value-format="YYYY-MM-DD HH:mm:ss" placeholder="选择日期时间">
                 </el-date-picker>
              </el-form-item>
           </el-col>
           <el-col :span="5">
              <el-form-item label="结束时间:">
                 <el-date-picker v-model="searchFoem.terminalTime" type="datetime" format="YYYY-MM-DD HH:mm:ss"
                 value-format="YYYY-MM-DD HH:mm:ss" placeholder="选择日期时间">
                 </el-date-picker>
              </el-form-item>
           </el-col>
        </el-row>
        <el-row >
         <el-col :span="5" v-if="searchFoem.department == '1'">
          <el-form-item label="班级:">
		        <el-cascader :props="props" :show-all-levels="false"  @change="cascaderClick"></el-cascader>
          </el-form-item>
        </el-col>
           <el-button type="primary" size="medium" class="query-button" @click="inquiryClick">查询</el-button>
           <el-button type="primary" size="medium"  @click="classExcel">班级Excel</el-button>
           <el-button type="primary" size="medium"  @click="studentExcel">学生Excel</el-button>


        </el-row>
     </div>
     <div class="list-box" v-if="searchFoem.department == '1' && searchFoem.checkTaskId != ''">
        <el-table  :border="true" class="table-Style"
           :header-cell-style="{ background: '#EDF6FF', color: '#000', }" ref="multipleTable"
           :data="tableData" tooltip-effect="dark" style="width: 100%">
           <!-- <el-table-column
              v-for="(item, index) in tableHeader"
              :key="index"
              :prop="item.prop"
              :label="item.label">
           </el-table-column> -->
           <!-- <el-table-column prop="studentId" label='学生id'></el-table-column> -->
           <el-table-column prop="studentName" label='学生姓名'></el-table-column>
           <el-table-column prop="studentNumber" label='学号'></el-table-column>
           <el-table-column prop="totalScore" label='总分'></el-table-column>
           <el-table-column
              v-if="tableHeader.length"
              v-for="(item, index) in tableHeader"
              :key="item.prop"
              :prop="item.prop"
              :label="item.label">
              <template #default="scope">
                 <!-- {{  tableData[] }} -->
                 <!-- <span v-for="(item_1,index_1) of scope.row.items" > -->
                    <!-- {{ scope.row.items[index].addScoreType == 0? scope.row.items[index]:scope.row.items[index] }} -->
                    {{  scope.row.items[index].score }}
                 <!-- </span> -->
               </template>
           </el-table-column>
           
        </el-table>
        <div class="block-student">
         <el-pagination :small="small" :disabled="disabled" :background="background" layout="prev, pager, next, jumper"
           :total="totalCount" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
       </div>
     </div>
     <div class="list-box" v-if="searchFoem.department == '2'&& searchFoem.checkTaskId != ''">
        <el-row class="list">
       <el-table stripe :border="true" :header-cell-style="{ background: '#EDF6FF', color: '#000', }"
         ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" v-loading="loading"
         @selection-change="handleSelectionChange">
         <el-table-column prop="className" label='班级名称'>
         </el-table-column>
         <el-table-column prop="gradeName" label="年级名称">
         </el-table-column>
         <el-table-column prop="ranking" label="排名">
         </el-table-column>
         <el-table-column prop="score" label="分数">
         </el-table-column>
         <el-table-column prop="userCount" label="人数">
        </el-table-column>
       </el-table>

       <div class="block-fenye">
         <el-pagination :small="small" :disabled="disabled" :background="background" layout="prev, pager, next, jumper"
           :total="totalCount" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
       </div>
     </el-row>
     </div>
   </div>
</template>
<script>
import { GetTaskList,GetClassFormlist,GetStudentFormlist,checkTaskclassExport ,checkTaskStudentExport} from '@/assets/api/deyu.js';
import { getGradeList, getFindClassList,findTeacherInfo } from '@/assets/api/renyuan';



export default {
   name: '',
   components: {
     
   },
   mixins: [],
   props: {
     
   },

   data() {
     return {
        searchFoem: {
           department: '',
           startTime: '',
           checkTaskId:'',
           terminalTime:'',
           class:''

           
        },
        pageInfo: {
           page: 1,
           pageSize: 10,
           },
        departmentList: [
           {
              value: '2',
              label: '学校班级排名报表'
           },
           {
              value: '1',
              label: '部门学生统计报表'
           },
        ],
        tableHeader: [
           // { label: '标准名称', prop: 'standardName' },
           // { label: '项目名称', prop: 'itemName' },
        ],
        taskName:[],
        tableData:[],
        totalCount:0,
        props: {
        lazy: true,
        lazyLoad:async(node, resolve) => {
          const {
            level
          } = node;
          let data
          if (level) {
            data =  await this.classClick(level,node.data)
          }
          console.log('data',data);
          setTimeout(() => {
            let nodes
            nodes = level ? data : this.options
            console.log('nodes',nodes);
            resolve(nodes);
          }, 1000);
        },
        value: 'id',
        label: 'name',
        children: 'children'
      },
     }
   },
   computed: {
     
   },
   watch: {
     
   },
   mounted() {
     
   },
   created(){
     // console.log(this.getTaskName);
   //   this.getTaskName()
     this.Lookteacher()

     
   },
   methods: {
    Lookteacher() {
      let params = {
        userId: JSON.parse(localStorage.getItem('user')).id,
      }
      findTeacherInfo(params).then((res) => {
      //   console.log(res, '查看权限');
        this.teacherObj = res.data.data
        if (this.teacherObj.schoolId && this.teacherObj.schoolId != '' && this.teacherObj.schoolId != null) {
          this.schoolClick()
        }
      }).catch((err) => {
        console.log(err);
      })
    },
    schoolClick() {
      let params = {
        page: '1',
        pageSize: '999',
      }
      getGradeList(params, this.teacherObj.schoolId).then((res) => {
      //   console.log(res, '年级列表');
        this.options = res.data.data.list
        for (let val of this.options) {
          val.sln_type = '年级'
          val.childrenShow = false
        }
      }).catch((err) => {
        console.log(err);
      })
    },
   classClick(level,item) {
      let params = {
        page: '1',
        pageSize: '999',
      }
      return new Promise((resolve)=> {
        getFindClassList(params, item.id).then((res) => {
         //  console.log(res.data.data.list, '班级列表');
          for (let val of res.data.data.list) {
            val.leaf = level >= 1
          }
          resolve(res.data.data.list)
        }).catch((err) => {
          console.log(err);
        })
      })
    },
    cascaderClick(value) {
      this.searchFoem.class = value[value.length - 1]
      // console.log(value, '联机', this.Dform.floor);
    },
      studentExcel(){
         const params = {
           checkTaskId:this.searchFoem.checkTaskId,
           startTime:this.searchFoem.startTime,
           endTime:this.searchFoem.terminalTime,
           page: this.pageInfo.page,
           pageSize: this.pageInfo.pageSize,
           userId: JSON.parse(localStorage.getItem('user')).id,
           classId:this.searchFoem.class

         }
      checkTaskStudentExport(params).then(res => {
        this.handleExport(res.data, '学生报表.xls')
      //   ElMessage({ message: '任务统计导出成功', type: 'success', })

      }).catch((err) => {
        // console.log(err);
        this.$message({
          type: 'error',
          message: err.response.data.msg
        });

      })
         
      },
      classExcel(){
         const params = {
           checkTaskId:this.searchFoem.checkTaskId,
           startTime:this.searchFoem.startTime,
           endTime:this.searchFoem.terminalTime,
           page: this.pageInfo.page,
           pageSize: this.pageInfo.pageSize,
           userId: JSON.parse(localStorage.getItem('user')).id,
         }
      checkTaskclassExport(params).then(res => {
        this.handleExport(res.data, '班级报表.xls')
      //   ElMessage({ message: '任务统计导出成功', type: 'success', })

      }).catch((err) => {
        // console.log(err);
        this.$message({
          type: 'error',
          message: err.response.data.msg
        });

      })
         
      },
     changeBtn(){
        if (this.searchFoem.department == '1') {
           this.getTaskName()
           this.StudentList()
           
        } if (this.searchFoem.department == '2') {
           this.getTaskName()
           this.classList()
           
        }
     },
     inquiryClick(){
        if (this.searchFoem.department == '1') {
           this.StudentList()
           
        } if (this.searchFoem.department == '2') {
           this.classList()
           
        }
     },
     StudentList(){
        const params ={
           checkTaskId:this.searchFoem.checkTaskId,
           startTime:this.searchFoem.startTime,
           endTime:this.searchFoem.terminalTime,
           page: this.pageInfo.page,
           pageSize: this.pageInfo.pageSize,
          userId: JSON.parse(localStorage.getItem('user')).id,
          classId:this.searchFoem.class
        }
        GetStudentFormlist(params).then((res) => {
           console.log(res, '学生报表');
              this.tableData = res.data.data.data
              this.totalCount =  res.data.data.totalCount

              if ( res.data.data.data.length ) {
                 console.log(res.data.data.data[0],999999);
                 res.data.data.data[0].items.forEach((item)=> {
                    if ( item.addScoreType == 0 ){
                       item.label = item.itemName
                       item.itemScore = item.score
                    } else if ( item.addScoreType == 1 ) {
                       item.label = item.standardName
                       item.itemScore = item.score
                    }
                 })
                 // this.tableData.forEach((item)=> {
                 //    item.prop = 'itemScore'
                 //    item.items.forEach((item2)=> {
                 //       item.addScoreType = item2.addScoreType
                 //       item.itemScore = item2.score

                 //    })
                 // })
                 this.tableHeader = res.data.data.data[0].items
              }
              console.log(this.tableData,'*****');
              console.log(this.tableHeader,'666666');
        }).catch((err) => {
           console.log(err);
        })
     },
     classList(){
        const params ={
           checkTaskId:this.searchFoem.checkTaskId,
           startTime:this.searchFoem.startTime,
           endTime:this.searchFoem.terminalTime,
           page: this.pageInfo.page,
           pageSize: this.pageInfo.pageSize,
           userId: JSON.parse(localStorage.getItem('user')).id,
 
        }
        GetClassFormlist(params).then((res) => {
        console.log(res.data.data.data, '班级报表');
        this.tableData = res.data.data.data
        this.totalCount =  res.data.data.totalCount
        }).catch((err) => {
        console.log(err);
        })
     },
     //任务名称列表
     getTaskName() {
        const params = {
        checkUserType:this.searchFoem.department == '1'? 'student':'class',
        page: this.pageInfo.page,
        pageSize: this.pageInfo.pageSize,
        userId: JSON.parse(localStorage.getItem('user')).id,
        }
        GetTaskList(params).then((res) => {
        this.taskName = res.data.data.list
        console.log(res, '任务名称');
        }).catch((err) => {
        console.log(err);
        })
     },
     handleCurrentChange(val) {
     this.pageInfo.page = val
     // this.getTongjiList()
     if (this.searchFoem.department == '1') {
           this.StudentList()
           
     } if (this.searchFoem.department == '2') {
        this.classList()
        
     }
     },
     handleExport(data, name) {
      // 动态创建iframe下载文件
      let fileName = name;
      if (!data) {
        return;
      }
      let blob = new Blob([data], { type: "application/octet-stream" });
      console.log(blob);
      if ("download" in document.createElement("a")) {
        // 不是IE浏览器
        let url = window.URL.createObjectURL(blob);
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // 下载完成移除元素
        window.URL.revokeObjectURL(url); // 释放掉blob对象
      } else {
        // IE 10+
        window.navigator.msSaveBlob(blob, fileName);
      }
    },
     }
};
</script>
<style lang='scss' scoped>
.box {
  width: 100%;
  height: 96%;
  overflow: auto;
  background-color: #fff;
  .fuzzy-matching-top {
     // margin-top: 35px;
     
        /deep/ {
           .el-row{
              margin-top: 20px;
           }
           .el-select--small .el-select__wrapper {
              height: 35px;
           }

           .el-form-item--small .el-form-item__label {
              // background-color: red;
              font-size: 16px;
           }

           .el-form-item--small .el-form-item__label {
              width: 100px;
              text-align: right;
              height: 35px;
              line-height: 35px;
           }

           .el-input {
              // width: 100%;
              height: 35px;
           }
           .el-cascader--small {
              width: 100%;
           }
           .el-select--small .el-select__wrapper{
              width: 220px;
           }
           .el-select .el-input__wrapper{
            width: 240px;
           }

   }
      .query-button{
         margin-left: 50px;
      }

}
  .list-box {
     // margin-top: 20px ;
     padding: 30px 20px ;
     background-color: #fff;
     border-radius: 8px;
     height: 80% ;
     overflow: auto;
     .table-Style {
        font-size: 14px;
     }
     /deep/ {
        .el-table {
        }
        .el-table th.el-table__cell>.cell {
           height: 30px;
           line-height: 30px;
           text-align: center;
           font-size: 16px;
           font-weight: 700;
        }

        .el-table td.el-table__cell div {
           text-align: center;
           // height: 40px;
           // line-height: 40px;
           border: 0;
           font-size: 16px;
           color: black;
        }

        .el-table:not(.el-table--border) .el-table__cell {
           // border: 0;
        }

        .el-button--small {
           padding-left: 19px;
        }
        .el-table--enable-row-transition .el-table__body td.el-table__cell {
         height: 40px !important;
        }
     }
     .block-fenye {
       // float: right;
       position: absolute;
     //   bottom: 0px;
       left: 50%;
       top: 110%;
       transform: translate(-50%, 0);

     }
     .block-student {
       // float: right;
       position: absolute;
       bottom: 80px;
       left: 50%;
     //   top: 80%;
       transform: translate(-50%, 0);

     }
  }
}
</style>